import BeekeeperHomeScreen from '@beekeeper/home-screen-sdk';

import {widgetTypeName} from '../config/config';
import widget from './components/Widget.vue';

BeekeeperHomeScreen.registerVueWidget(widgetTypeName, widget, {
  useStore: false,
});
